<template>
	<div class="icons-container mx-auto">
		<div class="flex justify-around my-6 py-2">
			<icon name="php"></icon>
			<icon name="laravel"></icon>
			<icon name="wordpress"></icon>
			<icon name="mysql"></icon>
		</div>
		<div class="flex justify-around my-6 py-2">
			<icon name="javascript"></icon>
			<icon name="nodejs"></icon>
			<icon name="vuejs"></icon>
			<icon name="react"></icon>
		</div>
		<div class="flex justify-around my-6 py-2">
			<icon name="html5"></icon>
			<icon name="css3"></icon>
			<icon name="bootstrap"></icon>
			<icon name="sass"></icon>
		</div>
		<div class="flex justify-around my-6 py-2">
			<icon name="webpack"></icon>
			<icon name="jquery"></icon>
			<icon name="git"></icon>
			<icon name="github"></icon>
			<!-- <icon name="heroku"></icon> -->
		</div>
	</div>
</template>

<script>
	import Icon from '@/components/Icon.vue';

	export default {
		components: { Icon }
	}
</script>
